module.exports = __webpack_public_path__ + "img/art-46.f9ed1b61.png";